<div class="field">
  <div class="badge" *ngFor="let item of items">
    <span class="label">{{item.label}}</span>
    <span class="clear" *ngIf="clearButton" (click)="clear(item.value)">×</span>
  </div>
</div>
